export default __webpack_public_path__ + "67fef680776a920da172dab7b0f99af1.mov";